class VariantSelector {
  constructor(container) {
    this.container = container;
    this.productId = container.dataset.productId;
    this.variantInput = container.querySelector("[data-variant-input]");
    this.radioInputs = container.querySelectorAll('input[type="radio"]');
    this.currentSelections = {
      option1: null,
      option2: null,
      option3: null,
    };

    this.init();
  }

  init() {
    this.setInitialSelections();

    this.radioInputs.forEach((input) => {
      input.addEventListener("change", (e) => this.handleOptionChange(e));
    });
  }

  setInitialSelections() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = parseInt(urlParams.get('variant'));
    const variantData = this.getVariantData();

    const currentVariant = variantId
      ? variantData.find((v) => v.id === variantId)
      : variantData.find((v) => v.available) || variantData[0];

    if (currentVariant) {
      this.currentSelections.option1 = currentVariant.option1 || null;
      this.currentSelections.option2 = currentVariant.option2 || null;
      this.currentSelections.option3 = currentVariant.option3 || null;
    }
    console.log('[init] currentVariant:', currentVariant ? `${currentVariant.title} (${currentVariant.id})` : 'NOT FOUND');
    console.log('[init] currentSelections:', JSON.stringify(this.currentSelections));
  }

  handleOptionChange(event) {
    const changedInput = event.target;
    const level = changedInput.dataset.level;
    const newValue = changedInput.value;

    this.currentSelections[`option${level}`] = newValue;

    this.updateDependentOptions(level);
    this.selectMatchingVariant(level);
  }

  updateDependentOptions(changedLevel) {
    const levelNum = parseInt(changedLevel);

    for (let i = levelNum + 1; i <= 3; i++) {
      this.updateOptionLevel(i);
    }
  }

  updateOptionLevel(level) {
    const levelInputs = this.container.querySelectorAll(
      `input[data-level="${level}"]`
    );
    if (!levelInputs.length) return;

    const previousSelections = {};
    for (let i = 1; i < level; i++) {
      previousSelections[`option${i}`] = this.currentSelections[`option${i}`];
    }

    const availableOptions = this.getAvailableOptionsForLevel(
      level,
      previousSelections
    );

    let hasChecked = false;
    let prevColorDisplayName = null;
    if (level === 2) {
      prevColorDisplayName = this.getColorDisplayName(
        this.currentSelections.option2
      );
    }

    levelInputs.forEach((input) => {
      const optionDiv = input.closest("div[data-value]");
      const isAvailable = availableOptions.includes(input.value);
      if (level === 1) {
        if (isAvailable) {
          optionDiv.style.display = "block";
          input.disabled = false;
        } else {
          optionDiv.style.display = "none";
          input.disabled = true;
          if (input.checked) {
            input.checked = false;
          }
        }
      } else {
        if (isAvailable) {
          optionDiv.style.display = "block";
          input.disabled = false;
        } else {
          optionDiv.style.display = "none";
          input.disabled = true;
          if (input.checked) {
            input.checked = false;
          }
        }
      }
      if (input.checked) hasChecked = true;
    });

    if (!hasChecked) {
      let found = false;
      if (level === 2 && prevColorDisplayName) {
        for (const input of levelInputs) {
          if (
            availableOptions.includes(input.value) &&
            this.getColorDisplayName(input.value) === prevColorDisplayName &&
            !input.disabled
          ) {
            input.checked = true;
            this.currentSelections[`option${level}`] = input.value;
            input.dispatchEvent(new Event("change", { bubbles: true }));
            found = true;
            break;
          }
        }
      }
      if (!found) {
        const firstAvailable = Array.from(levelInputs).find((input) =>
          availableOptions.includes(input.value)
        );
        if (firstAvailable) {
          firstAvailable.disabled = false;
          firstAvailable.checked = true;
          this.currentSelections[`option${level}`] = firstAvailable.value;
          firstAvailable.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    }
  }

  getAvailableOptionsForLevel(level, previousSelections) {
    const availableOptions = [];
    const variantData = this.getVariantData();

    variantData.forEach((variant) => {
      let isMatch = true;
      if (level > 1) {
        for (let i = 1; i < level; i++) {
          if (
            previousSelections[`option${i}`] &&
            variant[`option${i}`] !== previousSelections[`option${i}`]
          ) {
            isMatch = false;
            break;
          }
        }
      }
      if (
        isMatch &&
        variant[`option${level}`] &&
        (variant.available === undefined || variant.available)
      ) {
        availableOptions.push(variant[`option${level}`]);
      }
    });
    return [...new Set(availableOptions)];
  }

  getVariantData() {
    if (window.tfxProduct && Array.isArray(window.tfxProduct.variants)) {
      return window.tfxProduct.variants;
    }
    return [];
  }

  selectMatchingVariant(level) {
    const variantData = this.getVariantData();
    const selections = this.currentSelections;
    const matchingVariant = variantData.find((variant) => {
      return (
        (!selections.option1 || variant.option1 === selections.option1) &&
        (!selections.option2 || variant.option2 === selections.option2) &&
        (!selections.option3 || variant.option3 === selections.option3)
      );
    });

    if (matchingVariant) {
      if (this.variantInput) {
        this.variantInput.value = matchingVariant.id;
        this.variantInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
      this.updateProductPrice(matchingVariant);
      this.updateVariantInUrl(matchingVariant);
      this.updateGalleryByVariant(matchingVariant);
      for (let i = level; i <= 3; i++) {
        this.toggleDropList(i, matchingVariant.id);
      }
    }
  }

  updateProductPrice(variant) {
    const defaultPriceBlock = document.querySelector(".default-product-price");
    if (defaultPriceBlock) defaultPriceBlock.remove();

    const priceBlocks = document.querySelectorAll(".product-price");
    priceBlocks.forEach((block) => block.classList.add("wp-hidden"));

    if (variant && variant.price != null) {
      const matchingPriceBlock = Array.from(priceBlocks).find((block) => {
        const blockPrice = parseInt(block.getAttribute("data-price"));
        const hasComparePrice =
          block.querySelector(".wp-line-through") !== null;
        const variantHasComparePrice = Boolean(
          variant.compare_at_price && variant.compare_at_price > variant.price
        );

        return (
          blockPrice === variant.price &&
          hasComparePrice === variantHasComparePrice
        );
      });

      if (matchingPriceBlock) {
        matchingPriceBlock.classList.remove("wp-hidden");
      }
    }
  }

  formatMoney(cents) {
    if (typeof cents === "string") cents = parseInt(cents, 10);

    return (cents / 100).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }

  updateVariantInUrl(variant) {
    if (!variant) return;
    const idInput = document.querySelector('input[name="id"]');
    if (idInput) idInput.value = variant.id;
    const titleInput = document.querySelector('input[name="title"]');
    if (titleInput) titleInput.value = variant.title;
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variant.id);
    window.history.replaceState({}, "", url.toString());
  }
  updateGalleryByVariant(variant) {
    const galleryItemId = variant?.featured_media?.id;
    const galleryItemPosition = variant?.featured_media?.position;
    if (!galleryItemId || !galleryItemPosition) {
      console.log(
        "Variant has no featured media — no gallery update performed."
      );
      return;
    }
    const targetGalleryItem = document.querySelector(
      `.gallery-item[data-target-id="${galleryItemId}"][data-position="${galleryItemPosition}"]`
    );
    if (!targetGalleryItem) {
      console.log("not found target gallery");
      return;
    }
    const galleryItemIndex = parseInt(targetGalleryItem.dataset.index, 10);
    document.dispatchEvent(
      new CustomEvent("product:select-media", {
        detail: {
          mediaId: String(galleryItemId),
          position: String(galleryItemPosition),
          index: Number.isNaN(galleryItemIndex) ? null : galleryItemIndex,
        },
      })
    );
  }
  getColorDisplayName(value) {
    if (!value) returnvalue;

    let name = value.split("|")[0].trim();
    const variantData = this.getVariantData();
    const option1Set = new Set();
    variantData.forEach((v) => {
      if (v.option1) option1Set.add(v.option1);
    });

    // For each prefix, also try the version with hyphens and spaces removed
    const prefixes = Array.from(option1Set)
      .flatMap((prefix) => {
        const normalized = prefix.replace(/[- ]/g, "");
        return [prefix, normalized];
      })
      .sort((a, b) => b.length - a.length);
    for (const prefix of prefixes) {
      if (name.startsWith(prefix + " ")) {
        return name.slice(prefix.length + 1);
      }
    }
    return name;
  }
  toggleDropList(option_index, variant_id) {
    const targetSelector = `.drop-list-options-container-${variant_id}-${option_index}`;
    const target = document.querySelector(targetSelector);
    if (target) {
      const allContainers = [...document.querySelectorAll("div")].filter(
        (div) =>
          [...div.classList].some((cls) =>
            cls.startsWith("drop-list-options-container")
          )
      );
      allContainers.forEach((container) => {
        container.classList.add("wp-hidden");
      });
      target.classList.remove("wp-hidden");
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const variantSelectors = document.querySelectorAll("variant-selects");
  variantSelectors.forEach((container) => {
    new VariantSelector(container);
  });
});

if (typeof window !== "undefined") {
  window.VariantSelector = VariantSelector;
}
